import React from 'react';

const SkeletonLine = ({ className = '' }) => (
  <span className={`flare-workspace-loading-skeleton-line ${className}`.trim()} />
);

const SkeletonMessage = ({ align = 'start', compact = false }) => (
  <div className={`flare-workspace-loading-skeleton-message is-${align}`}>
    <span className="flare-workspace-loading-skeleton-avatar" />
    <span className={`flare-workspace-loading-skeleton-bubble${compact ? ' is-compact' : ''}`}>
      <SkeletonLine />
      <SkeletonLine className="is-short" />
    </span>
  </div>
);

export default function WorkspaceLoadingSkeleton({ contentMaxWidth = 980 } = {}) {
  return (
    <div aria-hidden="true" className="flare-workspace-loading-skeleton">
      <div className="flare-workspace-loading-skeleton-messages" style={{ maxWidth: contentMaxWidth }}>
        <SkeletonMessage />
        <SkeletonMessage align="end" compact />
        <SkeletonMessage compact />
      </div>
      <div className="flare-workspace-loading-skeleton-composer">
        <div
          aria-disabled="true"
          className="flare-workspace-loading-skeleton-composer-box"
          style={{ maxWidth: contentMaxWidth }}
        >
          <span className="flare-workspace-loading-skeleton-composer-input">
            <SkeletonLine />
          </span>
          <span className="flare-workspace-loading-skeleton-composer-actions">
            <span className="flare-workspace-loading-skeleton-action" />
            <SkeletonLine className="is-mode" />
            <span className="flare-workspace-loading-skeleton-action" />
          </span>
        </div>
        <div className="flare-workspace-loading-skeleton-composer-footer" style={{ maxWidth: contentMaxWidth }}>
          <SkeletonLine className="is-footer" />
          <SkeletonLine className="is-footer is-short" />
        </div>
      </div>
    </div>
  );
}
